/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_All_FiltersInputs */

const en_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear All Filters`)
};

const es_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todos los filtros`)
};

const fr_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer tous les filtres`)
};

const de_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Filter löschen`)
};

const ja_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての絞り込みをクリア`)
};

const zh_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除所有筛选`)
};

const ar_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح كافة عوامل التصفية`)
};

const it_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella Tutti i Filtri`)
};

const ru_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить все фильтры`)
};

const pt_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar Todos os Filtros`)
};

const ko_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 필터 지우기`)
};

/** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */
const id_clear_all_filters = en_clear_all_filters;

/**
* | output |
* | --- |
* | "Clear All Filters" |
*
* @param {Clear_All_FiltersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const clear_all_filters = /** @type {((inputs?: Clear_All_FiltersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_All_FiltersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_all_filters(inputs)
	if (locale === "es") return es_clear_all_filters(inputs)
	if (locale === "fr") return fr_clear_all_filters(inputs)
	if (locale === "de") return de_clear_all_filters(inputs)
	if (locale === "ja") return ja_clear_all_filters(inputs)
	if (locale === "zh") return zh_clear_all_filters(inputs)
	if (locale === "ar") return ar_clear_all_filters(inputs)
	if (locale === "id") return id_clear_all_filters(inputs)
	if (locale === "it") return it_clear_all_filters(inputs)
	if (locale === "ru") return ru_clear_all_filters(inputs)
	if (locale === "pt") return pt_clear_all_filters(inputs)
	return ko_clear_all_filters(inputs)
});